import { format, parseISO, isValid, type Locale } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { ptBR } from 'date-fns/locale'

type DateInput = string | Date | null | undefined

function toDate(input: DateInput): Date | null {
  if (!input) return null
  if (typeof input !== 'string') return isValid(input) ? input : null
  const d = parseISO(input)
  return isValid(d) ? d : null
}

export function formatUTC(
  date: DateInput,
  pattern: string,
  fallback = '',
  locale: Locale = ptBR
): string {
  const d = toDate(date)
  if (!d) return fallback
  return formatInTimeZone(d, 'UTC', pattern, { locale })
}

export function formatLocal(
  date: DateInput,
  pattern: string,
  fallback = '',
  locale: Locale = ptBR
): string {
  const d = toDate(date)
  if (!d) return fallback
  return format(d, pattern, { locale })
}

export function formatLocalCap(
  date: DateInput,
  pattern: string,
  fallback = '',
  locale: Locale = ptBR
): string {
  const result = formatLocal(date, pattern, fallback, locale)
  if (!result || result === fallback) return result
  return result.charAt(0).toUpperCase() + result.slice(1)
}
